import { useRef, useEffect, useState } from 'react';

const services = [
  {
    number: '01',
    icon: 'ri-movie-2-line',
    title: 'Content Production',
    desc: '방송, OTT, 디지털까지 – 기획부터 완성까지 제작합니다',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: 'Format Development',
    desc: '아이디어를 확장 가능한 콘텐츠 포맷과 IP로 설계합니다',
  },
  {
    number: '03',
    icon: 'ri-bar-chart-grouped-line',
    title: 'Distribution Strategy',
    desc: '콘텐츠가 확산되는 구조와 플랫폼 전략을 만듭니다',
  },
  {
    number: '04',
    icon: 'ri-links-line',
    title: 'Brand Integration',
    desc: '브랜드를 콘텐츠 안에 자연스럽게 통합합니다',
  },
];

export default function Services() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="w-full bg-white py-32 px-10 md:px-20">
      <div className="max-w-screen-xl mx-auto">

        {/* Centered Header */}
        <div className="text-center mb-20">
          <p className="font-sans-kr text-[11px] tracking-[0.3em] uppercase text-[#aaa] mb-5">
            Services
          </p>
          <h2 className="font-korean-serif text-[2.8rem] md:text-[3.4rem] font-light text-[#1a1a1a]" style={{ letterSpacing: '-0.01em' }}>
            우리가 하는 일
          </h2>
        </div>

        {/* Service Cards — bordered row */}
        <div
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-[#e0dbd5] border border-[#e0dbd5]"
        >
          {services.map((service, i) => (
            <div
              key={service.number}
              className={`flex flex-col px-10 py-14 transition-all duration-700 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${i * 130}ms` }}
            >
              {/* Number */}
              <p className="font-serif-display text-5xl text-[#ddd] font-light mb-10 leading-none">
                {service.number}
              </p>

              {/* Icon */}
              <div className="w-6 h-6 flex items-center justify-center mb-8">
                <i className={`${service.icon} text-xl text-[#555]`} />
              </div>

              {/* Title */}
              <h3 className="font-sans-kr text-[15px] font-medium text-[#1a1a1a] mb-3 tracking-wide">
                {service.title}
              </h3>

              {/* Dash */}
              <div className="w-5 h-px bg-[#ccc] mb-4" />

              {/* Description */}
              <p className="font-sans-kr text-[13px] text-[#888] font-light leading-[1.8]">
                {service.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
